<template>
  <div class="home">
    <!-- 顶部 -->
    <Tab :kexs="4"></Tab>
    <!-- body -->
    <div class="body">
      <el-empty
        v-if="list.length == 0"
        description="暂时没有数据哦~"
      ></el-empty>
      <div class="body-box" v-for="(item, index) in list" :key="index">
        <div class="body-box-left">
          <img :src="item.enclosure_images_text[0]" @error="errorImg" alt="" />
        </div>
        <div class="body-box-right">
          <div class="body-box-time">{{ item.createtime }}</div>
          <div class="body-con van-multi-ellipsis--l2">
            {{ item.title }}
          </div>
          <div class="ckxq pointer" @click="page(item.id)">查看详情</div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="page page1">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="6"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <div class="pointer tz">跳转</div>
      </div>
      <div class="page page2">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="6"
          layout="prev, pager, next"
          :total="total"
          small
        >
        </el-pagination>
      </div>
      <!-- 保障 -->
      <Guarantee></Guarantee>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Tab from "@/components/tab.vue";
import Footer from "@/components/footer.vue";
import Guarantee from "@/components/Guarantee.vue";
export default {
  name: "Notice",
  data() {
    return {
      currentPage3: 1, //默认分页
      total: 1, // 总数
      list: [], // 列表
      key: 0,
    };
  },
  mounted() {
    this.Notice(1);
  },

  components: {
    Tab,
    Footer,
    Guarantee,
  },
  methods: {
    errorImg(event) {
      this.$pk.errorImg(event);
    },
    page(id) {
      this.$router.push({
        name: "NoticeDetails",
        query: {
          id: id,
        },
      });
    },
    // 公告列表
    Notice(page) {
      // 公告列表
      this.$apis
        .Notice({
          page: page,
          pagesize: 6,
        })
        .then((res) => {
          this.total = res.data.total;
          this.list = res.data.data;
          for(let i in this.list){
            if(this.list[i].enclosure_images == ""){
              this.list[i].enclosure_images_text[0] = require("../../assets/image/zanwu.jpg")
            }
          }
          console.log(this.list)
        });
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.Notice(val);
      console.log(`当前页: ${val}`);
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style scoped='scoped'>
img {
  width: 100%;
  height: 100%;
}
i {
  font-size: 18px;
}
.home {
  overflow-x: hidden;
  background-color: #f5f5f5;
}
.body {
  width: 1136px;
  margin: 0 auto;
  padding: 16px 0 0;
}
/* 分页 */
.el-pagination >>> .el-pager li {
  padding: 0;
  margin: 0 4px;
}
.el-pagination >>> .el-pager li.active {
  background-color: #c7171e;
  color: #fff;
}
.page {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 0 56px;
}
.page2 {
  display: none;
}
.tz {
  width: 69px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #ffffff;
  font-size: 14px;
  color: #999;
  border-radius: 4px;
  border: 1px solid #c0c4cf;
}
/* 列表 */
.body-box {
  display: flex;
  margin-bottom: 20px;
}
.body-box-left {
  width: 56%;
  height: 270px;
}
.body-box-right {
  width: 44%;
  background-color: #fff;
  padding: 24px 32px;
  color: #666;
}
/*  */
.body-box-time {
  font-size: 16px;
}
.body-con {
  font-size: 20px;
  margin: 24px 0 64px 0;
}
.ckxq {
  width: 143px;
  height: 40px;
  background: #c7171e;
  font-size: 20px;
  color: #fff;
  line-height: 40px;
  text-align: center;
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
  .body {
    width: 98%;
    margin: 0 auto;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .body {
    width: 98%;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 767px) {
  .body {
    width: 95%;
    margin: 0 auto;
    padding: 10px 0 0;
  }
  .page1 {
    display: none;
  }
  .page2 {
    display: flex;
  }
  .body-box {
    flex-direction: column;
    box-shadow: 0px 2px 6px rgb(0 0 0 / 10%);
  }
  .body-box-left {
    width: 100%;
    height: 165px;
  }
  .body-box-right {
    width: 100%;
    background-color: #fff;
    padding: 10px 14px;
    color: #666;
  }
  .body-con {
    margin: 16px 0;
    font-size: 18px;
  }
  .ckxq {
    width: 116px;
    height: 30px;
    font-size: 15px;
    line-height: 30px;
  }
  .body-box-time {
    font-size: 14px;
  }
}
</style>
